import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const processInstanceHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: options([
      { value: 'Started', name: 'Started' },
      { value: 'Data Updated', name: 'Data Updated' },
      { value: 'User Task Completed', name: 'User Task Completed' },
      { value: 'Service Task Completed', name: 'Service Task Completed' },
      { value: 'Message Received', name: 'Message Received' },
      { value: 'Message Sent', name: 'Message Sent' },
      { value: 'Paused', name: 'Paused' },
      { value: 'Resumed', name: 'Resumed' },
      { value: 'Error Occurred', name: 'Error Occurred' },
      { value: 'Error Cleared', name: 'Error Cleared' },
      { value: 'Reprocessed', name: 'Reprocessed' },
      { value: 'Migrated', name: 'Migrated' },
      { value: 'Canceled', name: 'Canceled' },
      { value: 'Completed', name: 'Completed' },
    ]).describe('What happened to the process instance'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    processInstanceId: z
      .uuid()
      .hidden()
      .describe('Foreign key to ProcessInstance'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    processInstance: belongsTo('ProcessInstance'),

    tenant: references('Tenant'),
  })
  .describe("Records each significant event in a process instance's lifecycle")
  .as('ProcessInstanceHistory');

export { processInstanceHistory as processInstanceHistorySchema };
